import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const InfosBar = () => {
    const [currentText, setCurrentText] = useState(0);
    const navigate = useNavigate();

    const messages = [
        {
            text: "NOUVEAU PRODUIT : Basic PACK !",
            link: "/produit/BasicPack", 
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentText((prevText) => (prevText + 1) % messages.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [messages.length]);

    const handleClick = () => {
        navigate(messages[currentText].link);
    };

    return (
        <div
            className="fixed bg-[#005478] w-full z-40 h-10 flex text-center items-center justify-center cursor-pointer"
            onClick={handleClick} 
        >
            <p className="text-white text-xs md:text-sm font-semibold">{messages[currentText].text}</p>
        </div>
    );
};

export default InfosBar;
